export class UserLoggedOutMessage
{
}